export const environment = {
    production: false,
    apiUrl: 'https://api-dev-smer.municipiodurango.gob.mx',
    envName: 'Dev'
};
